import { defineComponent } from 'vue';

interface Stockist {
  name: string;
  image: string;
  storeLink: string;
  buyLink: string;
}

export default defineComponent({
  name: 'FindAStockist',
  setup() {
    const stockists: Stockist[] = [
      {
        name: 'Supa Quick',
        image: require('@/assets/images/falken/find-a-stockist/SupaQuick-logo.svg'),
        storeLink: 'https://www.supaquick.com/tyre-dealers-fitment-centres?utm_source=falken&utm_medium=website&utm_campaign=sqstorelocator',
        buyLink: 'https://shop.supaquick.co.za/'
      },
      // Add more stockists here
    ];

    return {
      stockists
    };
  }
});